var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainDiv"},[_c('p',{staticClass:"counter"},[_vm._v(_vm._s(_vm.counter.toLocaleString("en-IN"))+" +")]),_vm._m(0),_c('p',{staticClass:"bottomtext"},[_vm._v("Scroll down ⬇ to know more")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"middletext"},[_vm._v("Progressive "),_c('b',{staticStyle:{"color":"#37893c"}},[_vm._v("farmers")]),_vm._v(" and counting")])
}]

export { render, staticRenderFns }